"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const OEmbedType = {
  Photo: "photo",
  Video: "video",
  Link: "link",
  Rich: "rich"
};
exports.OEmbedType = OEmbedType;
//# sourceMappingURL=embed.cjs.map
